export class SpacesOccupationData {
  occupiedSites = 0;
  totalSites = 0;
  occupiedRooms = 0;
  totalRooms = 0;
}
